// extracted by mini-css-extract-plugin
export default {"closeBtn":"closeButton_closeBtn__JVU-h","closeIcon":"closeButton_closeIcon__K4rRA"};